import cx from "classnames";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import { FeatureGate, HttpStatusCode } from "@gamedev-web/gamedev-sdk-core";

import { spacing } from "../../helpers";
import { useResourceStrings } from "../../localization/hooks";
import { WithFeatureGateEnabled } from "../WithFeatureGate/WithFeatureGateEnabled";
import * as styles from "./ErrorPage.module.css";

type ErrorPageProps = Readonly<{
  error: Error;
  statusCode?: HttpStatusCode;
  pageType?: string;
  pageName?: string;
}>;

type ErrorPagePresentationalProps = Readonly<{
  title: string;
  subtitle?: string;
  errorCodeDisplayString?: string;
}> &
  ErrorPageProps;

export const ErrorPage = (props: ErrorPageProps) => {
  const [locErrorMessage, locErrorSubMessage] = useResourceStrings(
    "errorPageMessage",
    "errorPageSubMessage"
  );

  // TODO: handle errorCodeDisplayString
  return (
    <ErrorPagePresentational
      errorCodeDisplayString={""}
      title={locErrorMessage}
      subtitle={locErrorSubMessage}
      {...props}
    />
  );
};

// Todo @miczhong [Task: #27462144] capture error in CriticalErrorBoundary with error status code and return back from server.
export const ErrorPagePresentational = ({
  errorCodeDisplayString,
  error,
  subtitle,
  title,
}: ErrorPagePresentationalProps) => (
  <Container>
    <Row className={cx(styles.errorContainerRow, "justify-content-center", "align-items-center")}>
      <Col className="col-auto">
        <div className={cx(["text-center", spacing("margin", "topBottom", 5)])}>
          <h2>{title}</h2>
          {!!subtitle && <p>{subtitle}</p>}
          {errorCodeDisplayString && <p className={styles.errorCode}>{errorCodeDisplayString}</p>}
          <WithFeatureGateEnabled featureGate={FeatureGate.ShowStackOnError}>
            <p>{error.stack}</p>
          </WithFeatureGateEnabled>
        </div>
      </Col>
    </Row>
  </Container>
);

type GenericErrorPageProps = Readonly<{
  messageOverride?: string;
}>;

export const GenericErrorPage = ({ messageOverride }: GenericErrorPageProps) => {
  const errorMessage = "genericErrorMessage";
  return (
    <div>
      <h3>{messageOverride || errorMessage}</h3>
    </div>
  );
};
